module.exports = __webpack_public_path__ + "img/12.2ec7f90d.png";